// PURPOSE: Recover from React render crashes and report safe metadata. CONTRACT: No private error text is displayed or transmitted. DEPENDS: React and error-reports. CEILING: No automatic reload loop.
import { Component, type ReactNode } from 'react';
import { captureBrowserError } from './error-reports';

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error) { captureBrowserError(error, 'boundary'); }
  render() {
    return this.state.failed ? <main className="fatal-error"><h1>The workspace couldn’t open this page.</h1><p>Reload to recover your session. Unsaved changes may need to be entered again.</p><button className="button primary" onClick={() => location.reload()}>Reload workspace</button></main> : this.props.children;
  }
}
